// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__yEiPH","list":"BalanceDue_list__2ofxc","listRow":"BalanceDue_listRow__1nfLA","total":"BalanceDue_total__2Z3S3"};